var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.name == 'home'),expression:"$route.name == 'home'"}],attrs:{"id":"particles-js"}}),_c('Header'),_c('div',{staticClass:"main-body"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }